﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";
import { validate, format } from "rut.js";

import { Row, Col, Form, Modal, Button } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import { hasPermission, validRoles } from "@/services/Utils";
import api from "@/services/api.service";
import Fetching from "@/components/Fetching/Fetching";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const BusinessForm = ({ customers, confirmSave, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [name, setName] = useState("");
	const [code, setCode] = useState("");
	const [giro, setGiro] = useState("");
	const [customer, setCustomer] = useState("");

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleClose = () => {
		emptyFields();
		if (location.pathname.includes("configuracion")) {
			navigate("/configuracion/razones_sociales");
			return;
		}

		if (location.pathname.includes("mantenedores")) {
			navigate("/mantenedores/razones_sociales");
			return;
		}
	};

	const validSave = () => {
		if (!name) {
			addToast("Debe ingresar un nombre para guardar.", {
				appearance: "error",
			});

			return false;
		}

		if (!code || (code && !validate(code))) {
			addToast("Debe ingresar un RUT válido para guardar.", {
				appearance: "error",
			});

			return false;
		}

		if (!customer && location.pathname.includes("mantenedores")) {
			addToast("Debe seleccionar un cliente para guardar.", {
				appearance: "error",
			});

			return false;
		}

		return true;
	};

	const handleSave = () => {
		const form = {
			slug,
			name,
			code: format(code),
			giro,
			customer,
		};

		if (validSave()) {
			confirmSave(form, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setName("");
		setCode("");
		setGiro("");
		setCustomer("");
	};

	const afterSave = () => {
		handleClose();
		addToast("Razón Social guardada correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && slug) {
			api.get("/admin/business/detail", { slug }).then((response) => {
				const { detail } = response;
				if (detail) {
					setName(detail.name ? detail.name : "");
					setCode(detail.code ? detail.code : "");
					setGiro(detail.giro ? detail.giro : "");
					setCustomer(detail.customer_id ? detail.customer_id : "");
				} else {
					addToast("Ocurrió un problema al cargar la razón social seleccionada.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [slug, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Razón Social</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>

								<Form.Control value={name} onChange={(e) => setName(e.currentTarget.value)} type="text" />
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>RUT</Form.Label>

								<Form.Control value={code} onChange={(e) => setCode(e.currentTarget.value)} type="text" placeholder="11.321.963-5" />
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Giro</Form.Label>

								<Form.Control value={giro} onChange={(e) => setGiro(e.currentTarget.value)} type="text" />
							</Form.Group>
						</Col>

						{isAdmin && !location.pathname.includes("configuracion") && (
							<Col md={12} xs={12}>
								<Form.Group className={classes.group_form}>
									<Form.Label className={classes.label}>Cliente</Form.Label>
									<Select
										value={customers && customers.filter((c) => Number(c.value) === Number(customer))}
										placeholder={<div>Seleccione</div>}
										options={customers ? customers : []}
										onChange={(value) => setCustomer(value ? value.value : "")}
										components={{
											NoOptionsMessage,
										}}
										isClearable
									/>
								</Form.Group>
							</Col>
						)}
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default BusinessForm;
